var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      zIndex: 1,
      position: "relative"
    },
    width: 854,
    height: 240,
    viewBox: "0 0 854 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n                            .text {\n\t\t\t\t\t\tfont-size: 50px;\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\tfont-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji;\n\t\t\t\t\t}\n\t\t\t\t\t.desc {\n\t\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tfont-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji;\n\t\t\t\t\t}\n                            \n                        ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(427, 120) scale(1, 1) translate(-427, -120)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c6acf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E6B9F7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#linear)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0L 0 160Q 213.5 200 427 170T 854 195L 854 0 Z;M0 0L 0 185Q 213.5 200 427 180T 854 170L 854 0 Z;M0 0L 0 205Q 213.5 175 427 205T 854 170L 854 0 Z;M0 0L 0 160Q 213.5 200 427 170T 854 195L 854 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#linear)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-10s",
    values: "M0 0L 0 175Q 213.5 220 427 190T 854 200L 854 0 Z;M0 0L 0 190Q 213.5 160 427 160T 854 180L 854 0 Z;M0 0L 0 185Q 213.5 165 427 190T 854 205L 854 0 Z;M0 0L 0 175Q 213.5 220 427 190T 854 200L 854 0 Z"
  })))), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    alignmentBaseline: "middle",
    x: "50%",
    y: "50%",
    className: "text",
    style: {
      fill: "#ffffff"
    },
    stroke: "#none",
    strokeWidth: 1
  }, "Hello World\u270B I'm Hyeji!"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.92a97c299606be81213a30a9f69a9ed4.svg";
export { ForwardRef as ReactComponent };